module.exports = __webpack_public_path__ + "img/code.a9cbabda.png";